// Private flags kept with the reviewer's review marks (MarksStore, marks
// API version 2): things only they see, about a thread or a draft, that
// follow them to every device. Each is an anchor on a path starting `./`:
// a `.` path component, which no Git path has, so a flag never names a
// file, and MarksStore keeps flags out of the line marks the review model
// reads (`MarksStore.flags`). Kinds:
//
//   ./thread/<thread ID>  a review thread marked reviewed (threadMarks.ts)
//   ./aside/<draft ID>    a draft set aside from the review (asides.ts)
import type { Anchor } from './anchors';

/** Where every flag's path starts. */
export const FLAG_PATH = './';

/** Whether `a` is a flag rather than lines read. */
export const isFlag = (a: Anchor): boolean => a.path.startsWith(FLAG_PATH);

/**
 * A 40-hex-digit digest of `text` (the server takes a mark's blob as a
 * SHA-1's shape): five FNV-1a passes with different offsets. Not for
 * secrecy; equal texts give equal digests, and a changed one, all but
 * surely, another.
 */
export function digest(text: string): string {
  let out = '';
  for (let pass = 0; pass < 5; pass++) {
    let h = (0x811c9dc5 ^ Math.imul(pass + 1, 0x9e3779b1)) >>> 0;
    for (let i = 0; i < text.length; i++) h = Math.imul(h ^ text.charCodeAt(i), 0x01000193);
    out += (h >>> 0).toString(16).padStart(8, '0');
  }
  return out;
}

/** A flag on `path`, its blob `blob`. */
export const flag = (path: string, blob: string): Anchor => ({ path, side: 'new', blob, startLine: 1, endLine: 1 });
